<script setup lang="ts">
import { onBeforeMount } from "vue";
import { useRoute } from "vue-router";
import { useAuthStore } from "./stores/auth";
import Navbar from "./components/Navbar.vue";
import Notifications from "./components/Notifications.vue";

const route = useRoute();
const auth = useAuthStore();

onBeforeMount(() => {
  if (/\/invite(?!s)/.test(window.location.pathname)) return;
  auth.refresh();
});
</script>

<template>
  <Navbar
    v-if="route.name"
    :is-hidden="['login', 'not-found', 'invite'].includes(route.name as string)"
  />
  <main>
    <router-view></router-view>
  </main>
  <Notifications />
</template>
